import { common, ready } from './src/js/common/common'

// Very old CSS
import '../.css/styles.css'
// Old CSS
import './css/index.css'

async function index() {
  ready(async () => {
    common()
  })
}

// noinspection JSIgnoredPromiseFromCall
index()
